if (document.querySelector('.krem-list')) {
  (async () => {
    const { KremListWidthCalculation } = await import('./modules/krem/ListWidthCalculation');
    new KremListWidthCalculation();
  })();
}

if (document.querySelector('[data-premise]')) {
  (async () => {
    const { KremSinglePremiseData } = await import('./modules/krem/KremSinglePremiseData');
    new KremSinglePremiseData();
  })();
}

if (document.querySelector('#modal-1')) {
  (async () => {
    const { Modal } = await import('./modules/Modal');
    Modal.getInstance();
  })();
}

if (document.querySelector('[data-premise-history]')) {
  (async () => {
    const { PriceHistory } = await import('./modules/krem/PriceHistory');
    new PriceHistory();
  })();
}
